"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.hero.title': 'Aktywacja Konta',
    'activate.hero.description': 'Witamy w IntHub! Aktywujemy Twoje konto, abyś mógł rozpocząć.',
    'activate.hero.login_link_text': 'Masz już aktywne konto?',
    'activate.hero.login_link': 'Zaloguj się tutaj',
};
